<template>
<vs-row align="center">
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
        <table>
            <tr>
                <td style="padding: 0px 0px 50px 0px;">
                    Seleccione el libro al que desea transferir las unidades.
                    <v-select :options="librosFiltrados" class="mb-4 w-full" placeholder="--Seleccione--" v-model="libroSelecttranferir" label="nombrelibro" :reduce="librosFiltrados => librosFiltrados" ref="libroSelecttranferir" :class="classvalidar_libroSelecttranferir" />
                </td>
            </tr>
        </table>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
        <br>
        <vs-button @click="libroSeleccionado()" type="relief">Transferir Unidades</vs-button>
    </vs-col>
</vs-row>
</template>

<script>
import vSelect from "vue-select";
export default {
    data() {
        return {
            librosFiltrados: [],
            libroSelecttranferir: '',
            classvalidar_libroSelecttranferir: '',
        };
    },
    components: {
        "v-select": vSelect,
    },
    props: {
        libroSelect: {
            type: Object,
            default: function () {
                return {}
            }
        },
        libros: {
            type: Array,
            default: function () {
                return []
            }
        },
    },
    mounted() {
        let me = this;
        me.librosFiltrados = this.libros.filter(libro => libro.idlibro !== this.libroSelect.idlibro);
    },
    methods: {
        validarcampo_buscar_libroSelecttranferir() {
            let me = this;
            const focus_libroSelecttranferir = me.$refs.libroSelecttranferir.$el.querySelector('input');
            focus_libroSelecttranferir.focus();
            me.classvalidar_libroSelecttranferir = 'stylevalidar';
            //Notificación de vacio
            me.$vs.notify({
                text: "Seleccione el libro que va a recibir la transferencia de unidades.",
                color: 'warning',
                iconPack: 'feather',
                icon: 'icon-alert-triangle',
                time: 8000,
            });
            // Quitar la clase después de la duración de la animación
            setTimeout(() => {
                me.classvalidar_libroSelecttranferir = '';
            }, 1500); // Ajusta según la duración de tu animación
        },
        libroSeleccionado() {
            let me = this;
            if ((me.libroSelecttranferir == 'undefined') || (me.libroSelecttranferir == '') || (me.libroSelecttranferir == null)) {
                me.validarcampo_buscar_libroSelecttranferir();
                return;
            }
            let datos = {
                "libro_a_transferir": me.libroSelect.idlibro,
                "libro_recibir_transferencia": me.libroSelecttranferir.idlibro,
            }
            console.log(datos, "data a enviar")
            console.log(datos);

            // return;
            me.$vs.loading()
            //axios.post(this.$apifacturacion_url + 'f_Vendedor', datos)
            this.$http.post(this.$server_url + 'transferenciaUnidades', datos)
                .then(res => {
                    me.$vs.loading.close()
                    // this.getMaterialcubiertaParametro();
                    me.$vs.notify({
                        text: 'Unidades transferidas con éxito.',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })
                    this.$emit('change', {
                        verificacionemittransferencia: 1
                    });
                })
                .catch(function () {
                    me.$vs.loading.close()
                    me.$vs.notify({
                        text: 'Las unidades no se pudieron transferir',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-x'
                    })
                })
        },
        //SECCION GUARDAR NUEVO PRODUCTO
        // getNuevoContUserAgrupacion() {
        //     this.nuevoarray.ca_id = ''
        //     this.nuevoarray.idusuario = ''
        // },
    },
};
</script>

<style scoped>
.informacionformhijodehijo {
    z-index: 51002;
    /* Valor mayor que el del popup del padre */
    position: fixed;
    /* Asegúrate de que la posición sea adecuada */
}

.stylevalidar {
    /* border: 2px solid #00f; */
    box-shadow: 0px 0px 2px 4px #ff0000;
    border-radius: 5px;
}
</style>
